<script>
  import { createEventDispatcher, onMount } from 'svelte';
  import Tabs from '@components/Tabs.svelte';
  import QuestionsTab from './QuestionsTab.svelte';
  import CreatorSpotlightAjax from '@ajax/creator_spotlight';

  const dispatch = createEventDispatcher();
  export let mobile = false;
  let items;

  const onQuestionSelect = function (val) {
    dispatch('goToAnswer', val);
  };

  const loadQuestions = async function () {
    let questions = await CreatorSpotlightAjax.getAllSpotlightQuestions();
    items = questions.categories.map((c, idx) => {
      return {
        label: c.name,
        value: idx + 1,
        component: QuestionsTab,
        props: {
          questions: c.questions,
          onQuestionSelect: onQuestionSelect,
        },
      };
    });
  };

  onMount(() => {
    loadQuestions();
  });
</script>

<style style="text/scss" lang="scss">
  .creator-spotlight-questions {
    .ui-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 24px;
      gap: 16px;
    }
    .ui-title {
      font-weight: 500;
      font-size: 18px;
      line-height: 22px;
      max-width: 350px;
    }
    .ui-subtitle {
      margin-bottom: 16px;
      color: #717171;
    }
    .ui-back,
    .ui-close {
      background-color: transparent;
      border: none;
      margin: 0;
      padding: 0;
      opacity: 0.5;

      &:hover {
        opacity: 1;
      }
    }
  }
</style>

<div class="creator-spotlight-questions" class:mobile={mobile}>
  <div class="ui-header">
    <button
      class="ui-back"
      on:click={() => {
        dispatch('back');
      }}>
      <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.85501 7.26609L10.5901 1.49831L11.6538 2.55596L5.91867 8.32373C5.82171 8.42125 5.82171 8.57877 5.91867 8.67628L11.6538 14.4441L10.5901 15.5017L4.85501 9.73393C4.17626 9.05132 4.17626 7.94869 4.85501 7.26609Z"
          fill="#1C1C1C" />
      </svg>
    </button>
    <div class="ui-title">Select Question</div>
    <button
      class="ui-close"
      on:click={() => {
        dispatch('close');
      }}
      ><svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6.93932 8.50003L2.00049 13.4386L3.06112 14.4993L8 9.56066L12.9389 14.4993L13.9995 13.4386L9.06069 8.50003L13.9995 3.56142L12.9389 2.50073L8 7.43939L3.06112 2.50073L2.00049 3.56142L6.93932 8.50003Z"
          fill="#1C1C1C" />
      </svg>
    </button>
  </div>

  <div class="question-tabs">
    <Tabs items={items} />
  </div>
</div>
